import React from 'react';
import {Link} from 'react-router-dom'

function Footer(props) {
    return (
        <div className="mt-6 pt-5 pb-5 footer">
<div className="container">
  <div className="row">
    <div className="col-lg-6 col-xs-12 about-company">
      <h2>CG-HELP</h2>
      <p className="pr-5 text-white-50"> We are helping people using social media and through this website. </p>
      <p className="pr-5 text-white-50"> You all can share your resource for our people in this website. </p>
      <p><a href="#"><i className="fa fa-facebook-square mr-1"></i></a><a href="#"><i className="fa fa-linkedin-square"></i></a></p>
    </div>
    <div className="col-lg-6 col-xs-12 links mb-4">
      <h4 className="mt-lg-0 mt-sm-3">Links</h4>
        <ul className="m-0 p-0">
          <li>- <a href="/">Home</a></li>
          <li>- <a href="/about">About</a></li>
        
          <li>- <a href="/resource">Resource</a></li>
        </ul>
    </div>
  
   
  </div>
  <div className="row mt-5">
    <div className="col copyright">
      <p className=""><small className="text-white-50">CGHELP+ © 2021. All Rights Reserved.</small></p>
    </div>
  </div>
</div>
</div>
    );
}

export default Footer;